import { cn } from '@/lib/utils';
import type { Classification } from '@/types/gated-resource';

const classificationConfig: Record<Classification, { label: string; className: string }> = {
  public:       { label: 'Public',       className: 'bg-status-allow/15 text-status-allow' },
  internal:     { label: 'Internal',     className: 'bg-status-info/15 text-status-info' },
  confidential: { label: 'Confidential', className: 'bg-status-warning/15 text-status-warning' },
  restricted:   { label: 'Restricted',   className: 'bg-status-deny/15 text-status-deny' },
};

interface ClassificationBadgeProps {
  classification: Classification;
  className?: string;
}

export function ClassificationBadge({ classification, className }: ClassificationBadgeProps) {
  const config = classification ? classificationConfig[classification] : undefined;
  if (!config) return <span className="text-xs text-muted-foreground">—</span>;
  return (
    <span className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', config.className, className)}>
      {config.label}
    </span>
  );
}
